import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/orderGuest";

export default class OrderGuestService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
